import { render, staticRenderFns } from "./EmailDetailForm.vue?vue&type=template&id=9d290f22&"
import script from "./EmailDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmailDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports